// extracted by css-extract-rspack-plugin
export default {"tile":"tile-YztNVA","name":"name-cXuFS2","caption":"caption-yk55cr"};